// extracted by mini-css-extract-plugin
export default {"cardContainer":"BoxShadowC_cardContainer__ZFOmi"};